import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { PlanJobStatusKind } from '../../utils/planJobStatus';

const STATUS_BUTTON_CONFIG = {
    [PlanJobStatusKind.VALIDATION_PROCESSING]: { color: 'primary', disabled: true },
    [PlanJobStatusKind.VALIDATION_ACTIVE]: {
        color: 'primary',
        onClick: (handlers, row) => handlers.onOpenValidation(row),
    },
    [PlanJobStatusKind.PROCESSING_FAILED]: { color: 'error', disabled: true },
    [PlanJobStatusKind.VALIDATION_CRITICAL]: {
        color: 'error',
        onClick: (handlers, row) => handlers.onOpenValidation(row),
    },
    [PlanJobStatusKind.VALIDATION_NON_CRITICAL]: {
        color: 'warning',
        onClick: (handlers, row) => handlers.onOpenValidation(row),
    },
    [PlanJobStatusKind.BOTMARK_ESTIMATE]: {
        color: 'secondary',
        onClick: (handlers, row) => handlers.onOpenBotmarkEstimate(row),
    },
    [PlanJobStatusKind.JOB_READY]: { color: 'secondary', disabled: true },
    [PlanJobStatusKind.JOB_COMPLETE]: { color: 'secondary', disabled: true },
    [PlanJobStatusKind.DOWNLOAD]: {
        color: 'success',
        onClick: (handlers, row) => handlers.onDownload(row),
    },
    [PlanJobStatusKind.DOWNLOAD_POLICY]: {
        color: 'warning',
        onClick: (handlers, row) => handlers.onShowPdf(row),
    },
    [PlanJobStatusKind.ACCEPT_DOWNLOAD]: {
        color: 'success',
        onClick: (handlers, row) => handlers.onAcceptAndDownload(row),
    },
    [PlanJobStatusKind.ACCEPT_DOWNLOAD_POLICY]: {
        color: 'primary',
        onClick: (handlers, row) => handlers.onShowPdf(row),
    },
    [PlanJobStatusKind.LOCKED_COMPANY]: {
        color: 'secondary',
        disabled: true,
        label: <div>Locked Company: Contact <b>Botweb</b></div>,
    },
    [PlanJobStatusKind.WAITING]: {
        color: 'secondary',
        disabled: true,
        wrapInDiv: true,
    },
};

export function PlanTableJobStatusCell({ row, status, handlers }) {
    if (status.kind === PlanJobStatusKind.STORAGE_LIMIT) {
        return (
            <Box>
                <Typography fontWeight="bold">
                    {status.sortLabel}
                </Typography>
            </Box>
        );
    }

    const config = STATUS_BUTTON_CONFIG[status.kind];
    if (!config) {
        return null;
    }

    const handleClick = config.onClick
        ? () => config.onClick(handlers, row)
        : undefined;
    const label = config.label
        ?? (config.wrapInDiv ? <div>{status.sortLabel}</div> : status.sortLabel);

    return (
        <Button
            variant="contained"
            color={config.color}
            disabled={Boolean(config.disabled)}
            onClick={handleClick}
        >
            {label}
        </Button>
    );
}
